export const alphaAmber = '#FFC10E';
export const alphaAmberLight = '#F6E3BA';
export const alphaBlack = '#212121';
export const alphaBlackTransparent = '#000000DE';
export const alphaBlue = '#00BBD7';
export const alphaBlueLight = '#80DDEB';
export const alphaGray = '#E9E9E9';
export const alphaGrayDark = '#A7A7A7';
export const alphaGrayDarker = '#828282';
export const alphaGrayLight = '#DDDDDD';
export const alphaGrayLighter = '#F0F0F0';
export const alphaGrayLighterTrans = '#0000000A';
export const alphaGrayStatus = '#828282';
export const alphaGreen = '#8AC256';
export const alphaGreenDark = '#558B2F';
export const alphaGreenLight = '#BFD9C2';
export const alphaLearningPillGreen = '#28A745';
export const alphaLearningPillRed = '#DC3534';
export const alphaOrange = '#FCA238';
export const alphaPink = '#EC959D';
export const alphaRed = '#FF2725';
export const alphaRedLight = '#F2D7D8';
export const alphaWhiteTransparent = '#FFFFFFDE';
export const alphaYellowLight = '#FDF9D1';

// color per subject
export const languageColor = '#9FCC73';
export const scienceColor = '#FF8256';
export const readingColor = '#033B77';
export const mathColor = '#00BAD7';
export const writingColor = '#B63838';
export const englishColor = '#F1A688';
export const worldLanguagesColor = '#492B07';
export const biologyColor = '#2A0101';
export const chemistryColor = '#39572F';
export const physicsColor = '#1A2258';
export const computerScienceColor = '#3B6065';
export const humanGeographyColor = '#7B8B75';
export const worldHistoryColor = '#CEA46F';
export const americanHistoryColor = '#3B1B36';
export const governmentColor = '#36F802';
export const economicsColor = '#FF5D00';
export const satPrepColor = '#727287';
export const testPrepColor = '#D008CD';
export const nonCoreSkillsColor = '#CE97D9';

export const timeColor = '#C2568A';
export const ringColor = '#0B98C1'
export const activityColor = '#578CC3';
export const progressColor = '#8AC256';
export const dailyRingColor = '#B3497C';

export const THEME_BASE = 'base';
export const THEME_INFO = 'info';
export const THEME_SUCCESS = 'success';
export const THEME_ERROR = 'error';
export const THEME_WARN = 'warning';
